<template>
  <div>
    <canvas ref="qrcode"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCodeGenerator',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.generateQRCode()
  },
  watch: {
    value() {
      this.generateQRCode()
    }
  },
  methods: {
    generateQRCode() {
      QRCode.toCanvas(this.$refs.qrcode, this.value, {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }, (error) => {
        if (error) console.error(error)
      })
    }
  }
}
</script>
